const availablePlateSize = [
    {
        "type": "small",
        "width": 25,
        "height": 10,
    },
    {
        "type": "medium",
        "width": 28,
        "height": 15,
    },
    {
        "type": "large",
        "width": 32,
        "height": 20,
    }
]

class AvailablePlateOptions {
    constructor() {
        this.availablePlateSize = availablePlateSize
    }
    getPlate(inType) {
        return this.availablePlateSize.find((plate) => plate.type === inType)
    }

}
const plateSizeOptions = new AvailablePlateOptions()
export default plateSizeOptions;